import getEnvVar from '../../../helper/envHelper';

export const fraudToolMixin = {
    methods: {
        includeFraudPackage() {
            return new Promise(function (resolve, reject) {
                const script = document.createElement('script');
                script.src = `${getEnvVar('FRAUD_URL')}/JS/Script/FraudClient`;
                script.onload = resolve;
                script.onerror = reject;
                document.head.appendChild(script);
            });
        },
        async injectFraudTool(
            fraudToolName,
            fraudToolParameters,
            sessionId,
            operatorCode,
            countryCode
        ) {
            try {

                this.loading = true; //from parent comp
                await window.TPay.FraudToolClient.injectFraudTool(
                    fraudToolName,
                    fraudToolParameters,
                    fraudToolName === 'Evina' ? '#paymentBtn' : null,
                    sessionId,
                    {
                        merchantName: this.merchantConfig.merchantName,
                        operatorCode: operatorCode,
                        countryIsoCode: countryCode,
                    }
                );
            }
            catch (error) {
                console.log('inject Fraud error', error);
            }
            this.loading = false; //from parent comp
        },
        async validateFraudTool(payload, sessionId) {
            const validateFraudToolResult =
                await window.TPay.FraudToolClient.validateFraudTool(
                    true, // [true, false] "getting the whole API response"
                    payload,
                    sessionId
                );
            /*========= response object Template ========== */
            // let validateFraudToolResult = {
            //   isUserClear: true,
            //   reason: {},
            //   sessionToken: '',
            // };
            /*============================================= */
            return validateFraudToolResult;
        },
    },
};
